// 渲染模块
define('page/search/mark-favorite', ['jquery', 'data/local-storage', 'log', 'widget/favorite-modal', 'common/login-state'], ($, cache, log, favoriteModal, loginState) => { // eslint-disable-line
    class MarkFavorite {
        constructor() {
            this.CACHE_KEY = 'favoritesCarIdList';
            this.getCarListUrl = '/api/user/favorite/list';
        }

        // 拿到收藏的carIdList 渲染页面
        init(container, type) {
            this.getCarIdList(100).then((carIdList) => {
                this.addFavorite(carIdList);
            });
            if (!this.isBindEvent) {
                this.type = type;
                this.bindEvents(container);
                this.isBindEvent = true;
            }
            const lc = localStorage.getItem('loginBackCarid');
            localStorage.removeItem('loginBackCarid');
            if (lc && $.cookie('rrc_login_token') && $.cookie('rrc_login_phone')) {
                this.ajaxAddFavorite({
                    token: $.cookie('rrc_login_token'),
                    carid: lc
                });
            }
        }

        // 拿到收藏的carIdList
        getCarIdList(count) {
            const token = $.cookie('rrc_login_token');
            const d = $.Deferred(); // eslint-disable-line
            let carIdList = cache.getItem(this.CACHE_KEY);
            if (!token) {
                d.resolve([]);
                return d.promise();
            }

            carIdList = carIdList !== null ? carIdList.split(',') : [];
            if (carIdList.length > 0) {
                d.resolve(carIdList.filter(item => item));
                return d.promise();
            }

            $.post(this.getCarListUrl, { token, count }, (idList) => {
                if (idList.data) {
                    idList.data.forEach((item) => {
                        carIdList.push(item.record_data);
                    });
                }
                cache.setItem(this.CACHE_KEY, carIdList.join(','), 7200);
                d.resolve(carIdList);
            }, 'json');

            return d.promise();
        }

        // 给所有收藏的车辆渲染
        addFavorite(carIdList) {
            carIdList.forEach((item) => {
                const $favoriteBtn = $(`.favorite-box[data-car-id=${item}]`);
                if ($favoriteBtn.length) {
                    $favoriteBtn.attr('hasCollected', 'yes').addClass('favorite-box-cur');
                }
            });
        }

        // 当前target 清楚收藏
        removeOneFavorite(carId) {
            return this.getCarIdList()
                .then((list) => {
                    const carIdList = list.filter(item => item !== carId);
                    cache.setItem(this.CACHE_KEY, carIdList.join(','), 7200);
                    this.removeFavorite(carId);
                });
        }

        // 给当前触发收藏的按钮添加样式
        addOneFavorite(carId) {
            return this.getCarIdList().then((carIdList) => {
                carIdList.push(carId);
                cache.setItem(this.CACHE_KEY, carIdList.join(','), 7200);
                this.addFavorite(carIdList);
            });
        }

        // 清楚所有的收藏
        removeFavorite(carId) {
            const $favoriteBtn = carId ? $(`.favorite-box[data-car-id=${carId}]`) : $('.favorite-box');
            if ($favoriteBtn.length === 0) {
                return;
            }
            if (!carId) {
                cache.removeItem(this.CACHE_KEY);
            }
            $favoriteBtn.attr('hasCollected', 'no').removeClass('favorite-box-cur');
            return this;
        }

        // 给登录登出绑定事件 跟触发收藏的按钮绑定事件
        bindEvents(container) {
            const $container = $(container);
            const $body = $('body');
            $body.on('logout', () => {
                this.removeFavorite();
            });
            $body.on('login', () => {
                this.init();
            });
            $container.on('click', '.favorite-box', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const token = $.cookie('rrc_login_token');
                const $target = $(e.currentTarget);
                const status = $target.attr('hasCollected');
                // yes为已收藏 否则为还没收藏
                const carId = $target.attr('data-car-id');
                const data = { token: token, carid: carId, };// eslint-disable-line
                if (status !== 'yes') {
                    if (token && $.cookie('rrc_login_phone')) {
                        return this.ajaxAddFavorite(data);
                    }
                    localStorage.setItem('loginBackCarid', carId);
                    window.location.href = `${window.location.origin}/login?source=${encodeURIComponent(window.location.href)}`;
                    // return this.addByIsLogin(data, this.ajaxAddFavorite.bind(this));
                    return false;
                }
                return this.ajaxRemoveFavorite(data);
            });
        }

        // 业务dom 登录与没登录情况触发收藏
        addByIsLogin(data, callback) {
            loginState.switchToLogin((token) => {
                data.token = token; // eslint-disable-line
                callback(data);
            }, { modalCls: 'login-type-collect' });
        }

        // 请求添加收藏接口
        ajaxAddFavorite(json) {
            json.ep = JSON.stringify({ fr: RRC.fr, page: this.type || '列表页', city: RRC.city }); // eslint-disable-line
            return $.post('/api/user/favorite/add', json, () => {
                favoriteModal.init();
                log.push(['_trackEvent', '收藏成功弹窗弹出', 'click', { car_id: json.carid, pageName: RRC.pageName }]);
                this.addOneFavorite(json.carid);
            }, 'json');
        }

        // 请求删除收藏接口
        ajaxRemoveFavorite(json) {
            json.ep = JSON.stringify({ fr: RRC.fr, page: this.type || '列表页', city: RRC.city }); // eslint-disable-line
            return $.post('/api/user/favorite/remove', json, () => {
                this.removeOneFavorite(json.carid);
                log.push(['_trackEvent', '收藏取消按钮点击成功', 'click', { car_id: json.carid, pageName: RRC.pageName }]);
            });
        }
    }
    return new MarkFavorite();
});
